import { Component } from "react";
import { withRouter } from "react-router-dom";

class ScrollTop extends Component {
  componentDidUpdate(prevProps) {
    const prevLocation = prevProps.location;
    const location = this.props.location;

    if (prevLocation !== location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollTop);
